import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=179542b8&scoped=true&"
import script from "./PedidosTable.vue?vue&type=script&lang=js&"
export * from "./PedidosTable.vue?vue&type=script&lang=js&"
import style0 from "./PedidosTable.vue?vue&type=style&index=0&id=179542b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179542b8",
  null
  
)

export default component.exports